import { isBrowser } from 'ws-scripts/modules/environment';

const hasDetailedIncentivesWidget = () => {
	if (!isBrowser) {
		return false;
	}
	
	const widget = document?.querySelector('[data-widget-name="ws-detailed-incentives"]');
	
	// Check if widget exists
	if (!widget) {
		return false;
	}
	
	const hasChildren = widget.children && widget.children.length > 0;
	
	return hasChildren;
};

// For now this is considering modern headers and vehicle toolbar to offset height
// blue-flannel has a rally task(TA3024637) to update the existing calculateHeaderOffset() to handle modern headers
// TODO: in future use calculateHeaderOffset() to calculate header height.
const scrollToUDS = () => {
	if (window?.scrollTo) {
		const handleScroll = () => {
			const target = document?.getElementById('vehicle-build-offer');
			if (!target || typeof target.getBoundingClientRect !== 'function') {
				return;
			}

			// calculate header height
			const header = document.querySelector('.page-header');
			const headerHeight = header?.clientHeight || 0;

			// calculate vehicle toolbar height
			const vehicleToolbar = document.querySelector(
				'[data-widget-name="ws-vehicle-toolbar"]'
			);
			const vehicleToolbarHeight = vehicleToolbar?.clientHeight || 0;

			// default height to offset from above container
			const OFFSET_HEIGHT = 25;

			// height of page that already scrolled
			const pageYOffset = window.scrollY || 0;

			// calculate target top to scroll
			const targetTop = target.getBoundingClientRect().top;

			const heightAdj =
				targetTop +
				pageYOffset -
				(headerHeight + vehicleToolbarHeight + OFFSET_HEIGHT);

			window.scrollTo({ top: heightAdj, left: 0, behavior: 'smooth' });
		};

		handleScroll();
		// scroll again after the vehicle-toolbar is displayed
		setTimeout(() => handleScroll(), 500);
	}
};

export { hasDetailedIncentivesWidget, scrollToUDS };
